import { DBDef_LogTemplate } from '@app/advisor-content-shared';
import { createSearchIntegration } from '@app/styles';
import { ModuleFE_LogTemplate } from '../../_entity/log-tempalte/ModuleFE_LogTemplate.js';
import { ModuleFE_SmartDoc } from '../../_entity/smart-doc/ModuleFE_SmartDoc.js';
import { Manager_LogTemplate } from '../../ui/_managers/Manager_LogTemplate/Manager_LogTemplate.js';
import { ConfigDialogKeys_AdvisorContent, ConfigDialogs_AdvisorContent_Dialogs, ConfigDialogs_AdvisorContent_Labels } from '../../ui/config-dialogs/index.js';
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_LogTemplate,
    dbDef: DBDef_LogTemplate,
    tag: ['Lt', 'Log Template'],
    modulesToAwait: [ModuleFE_LogTemplate, ModuleFE_SmartDoc],
    ManagerComponent: Manager_LogTemplate,
    extraMenuSections: () => [{
            actions: ConfigDialogKeys_AdvisorContent.map(key => ({
                label: ConfigDialogs_AdvisorContent_Labels[key],
                action: () => ConfigDialogs_AdvisorContent_Dialogs[key].show(),
            })),
        }],
});
export const WorkHubItem_LogTemplate = WorkHubItem;
export const UtilObject_LogTemplate = UtilObject;
export const SearchItem_LogTemplate = SearchItem;
//# sourceMappingURL=log-template.js.map